// PageHeaderUser Component

import React from 'react'
import PropTypes from 'prop-types'

import PageHeaderBase from '../../../common/layout/page_header_base/page_header_base.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Acl from '../../../lib/acl.jsx'

class PageHeaderUser extends PageHeaderBase {
  static get propTypes () {
    return {
      title: PropTypes.string,
      pageIdent: PropTypes.string,
      hasFilterTab: PropTypes.bool,
      onChangePage: PropTypes.func,
      onChangeFilter: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      title: '',
      hasFilterTab: false,
      onChangePage: null,
      onChangeFilter: null
    }
  }

  renderContent () {
    const { pageIdent, title } = this.props
    const mainOptions = {
      title: IntlUtil.convertMessage(title),
      titleInfo: null,
      hasFilter: false,
      hasSearch: false,
      hasEdit: false,
      actions: [],
      onShowSearch: null,
      onShowFilter: null,
      rightInfo: null
    }
    const tabsUser = [
      {
        ident: 'user-profile',
        label: 'user.overview.overview'
      },
      {
        ident: 'user-schedule',
        label: 'user.schedule.schedule'
      },
      {
        ident: 'user-skills',
        label: 'user.skills.skills'
      },
      {
        ident: 'personal-setting',
        label: 'user.personal.settings'
      }
    ]

    const tabs = []
    tabsUser.map((tabitem, _idx) => {
      if (Acl.isPageAllowed(tabitem.ident)) {
        tabs.push(tabitem)
      }
    })

    const actionbarOptions = {
      tabsLeft: tabs,
      tabsLeftActive: pageIdent,
      onTabsLeftAction: this._onChangePage.bind(this)
    }

    if (!this.props.hasFilterTab) {
      actionbarOptions.actions = []
      actionbarOptions.tabsRight = []
    }

    return (
      <div className='userheader'>
        {this.renderMainPanel(mainOptions)}
        {this.renderActionBar(actionbarOptions)}
      </div>
    )
  }

  getClassName () {
    return 'userheader'
  }

  _onChangePage (pageIdent) {
    if (this.props.onChangePage) {
      this.props.onChangePage(pageIdent)
    }
  }

  _onChangeFilter () {
    if (this.props.onChangeFilter) {
      this.props.onChangeFilter(this.data)
    }
  }
}

export default PageHeaderUser
